import DashboardIcon from '@/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@/components/icons/sidebar/MaintanceIcon';
// import MessagesIcon from '@/components/icons/sidebar/messages';
import LocationIcon from '@/components/icons/sidebar/LocationIcon';
import {
    BarChart3,
    Package,
    UserIcon,
    Receipt,
    Banknote,
    Users,
    ClipboardList,
    Wallet,
    CreditCard,
    LayoutDashboard,
    Building2,
    Inbox,
    Settings2,
    CircleDollarSign,
    BookOpen,
    Target,
    Landmark,
    CalendarRange,
    FileSpreadsheet,
    Warehouse,
} from 'lucide-react';

/** Platform owner only — subscription management */
export const ownerNavigation = [
    {
        name: 'subscription_overview',
        icon: LayoutDashboard,
        activeIcon: LayoutDashboard,
        to: '/subscriptions',
        ownerOnly: true,
    },
    {
        name: 'subscription_plans',
        icon: CreditCard,
        activeIcon: CreditCard,
        to: '/subscriptions/plans',
        ownerOnly: true,
    },
    {
        name: 'subscription_tenants',
        icon: Building2,
        activeIcon: Building2,
        to: '/subscriptions/tenants',
        ownerOnly: true,
    },
    {
        name: 'subscription_users',
        icon: Users,
        activeIcon: Users,
        to: '/subscriptions/users',
        ownerOnly: true,
    },
    {
        name: 'subscription_requests',
        icon: Inbox,
        activeIcon: Inbox,
        to: '/subscriptions/requests',
        ownerOnly: true,
    },
    {
        name: 'subscription_platform_settings',
        icon: Settings2,
        activeIcon: Settings2,
        to: '/subscriptions/platform-settings',
        ownerOnly: true,
    },
];

export const navigationBottom = [
    // { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    {
        name: 'settings',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/settings',
        requiresPermission: 'list_setting',
    },
    // { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];
// // Service
export const ReportsSide = [
    { name: 'reports_page.tab_home', to: '/reports' },
    { name: 'reports_page.tab_products', to: '/reports?tab=products' },
    { name: 'reports_page.tab_invoices', to: '/reports?tab=invoices' },
    { name: 'reports_page.tab_inventory', to: '/reports?tab=inventory' },
    { name: 'warehouses.movement_report_title', to: '/warehouse-movements' },
    { name: 'warehouses.transfer_report_title', to: '/product-transfers' },
    { name: 'purchase_orders.purchase_reports_title', to: '/purchase-reports' },
];

export const PurchaseOrdersSide = [
    { name: 'purchase_orders.purchase_orders_list', to: '/purchase-orders' },
    { name: 'purchase_orders.companies_and_suppliers', to: '/companies-and-suppliers' },
    // { name: 'purchase_orders.purchase_reports_title', to: '/purchase-reports' },
];

export const WarehousesSide = [
    { name: 'warehouses.warehouses', to: '/warehouses' },
    { name: 'warehouse_inventory.warehouses_inventory', to: '/warehouse-inventory' },
    { name: 'warehouses.transfer_products_title', to: '/warehouse-transfers' },
    // { name: 'warehouses.movement_report_title', to: '/warehouse-movements' },
    // { name: 'warehouses.transfer_report_title', to: '/product-transfers' },
];

export const AccountsPeriodsSide = [
    { name: 'general_accounts_settings.page_title', to: '/general-accounts-settings' },
    { name: 'closed_periods.closed_periods', to: '/closed-periods' },
    { name: 'period_budget.page_title', to: '/period-budget' },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },

    {
        name: 'point_of_sale',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/point-of-sale',
        // requiresPermission: 'list_pos',
    },
    {
        name: 'customer',
        icon: UserIcon,
        activeIcon: UserIcon,
        to: '/customer',
        // requiresPermission: 'list_customer',
    },
    {
        name: 'invoices.invoices',
        icon: Receipt,
        activeIcon: Receipt,
        to: '/invoices',
    },
    {
        name: 'sales.sales',
        icon: Banknote,
        activeIcon: Banknote,
        to: '/sales',
    },
    {
        name: 'accounts_guide.accounts_guide',
        icon: BookOpen,
        activeIcon: BookOpen,
        to: '/accounts-guide',
    },
    {
        name: 'journal_entries.journal_entries',
        icon: FileSpreadsheet,
        activeIcon: FileSpreadsheet,
        to: '/journal-entries',
    },
    {
        name: 'cost_centers.cost_centers',
        icon: Target,
        activeIcon: Target,
        to: '/cost-centers',
    },
    {
        name: 'assets.assets_list',
        icon: Landmark,
        activeIcon: Landmark,
        to: '/assets',
    },
    {
        name: 'general_accounts_settings.menu',
        icon: CalendarRange,
        activeIcon: CalendarRange,
        to: '/general-accounts-settings',
        navigation: AccountsPeriodsSide,
        dropdownToggleOnly: true,
    },

    // {
    //     name: 'proforma_invoices.proforma_invoices',
    //     icon: FileText,
    //     activeIcon: FileText,
    //     to: '/proforma-invoices',
    // },
    {
        name: 'sellers.sellers',
        icon: Users,
        activeIcon: Users,
        to: '/sellers',
    },
    {
        name: 'purchase_orders.purchase_orders',
        icon: ClipboardList,
        activeIcon: ClipboardList,
        to: '/purchase-orders',
        navigation: PurchaseOrdersSide,
        dropdownToggleOnly: true,
    },
    {
        name: 'expenses.expenses',
        icon: Wallet,
        activeIcon: Wallet,
        to: '/expenses',
    },
    {
        name: 'products',
        icon: Package,
        activeIcon: Package,
        to: '/products',
        requiresPermission: 'list_product',
    },
    {
        name: 'warehouses.warehouses',
        icon: Warehouse,
        activeIcon: Warehouse,
        to: '/warehouses',
        navigation: WarehousesSide,
        dropdownToggleOnly: true,
    },

    // {
    //     name: 'marketing',
    //     to: '/marketing',
    //     icon: TwoUsersIcon,
    //     activeIcon: TwoUsersIcon,
    //     requiresPermission: 'list_marketing',
    // },
    {
        name: 'profit_report.profit_report',
        icon: CircleDollarSign,
        activeIcon: CircleDollarSign,
        to: '/profit-report',
        requiresPermission: 'list_report',
    },
    {
        name: 'reports',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/reports',
        navigation: ReportsSide,
        requiresPermission: 'list_report',
    },
    {
        name: 'permissions',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/permissions-page',
        requiresPermission: 'list_role',
    },
];
